<template>
  <v-card class="mt-5">
    <v-card-title>
      {{ $t("LABELS.EXPENSES") }}
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="$emit('add-row')">
        <v-icon left small>mdi-plus</v-icon>
        {{ $t("LABELS.ADD_ROW") }}
      </v-btn>
    </v-card-title>

    <table v-if="rows.length > 0" class="rows-table">
      <thead>
        <tr>
          <th class="name-header">{{ $t("FORM_LABELS.NAME") }}</th>
          <th class="code-header">{{ $t("FORM_LABELS.CODE") }}</th>
          <th class="machine-header">{{ $t("FORM_LABELS.MACHINE") }}</th>
          <th class="warehouse-header">
            {{ $t("FORM_LABELS.WAREHOUSE_ITEM") }}
          </th>
          <th class="qty-header">{{ $t("FORM_LABELS.QTY") }}</th>
          <th class="price-header">{{ $t("FORM_LABELS.PRICE") }}</th>
          <th class="total-price-header">
            {{ $t("FORM_LABELS.TOTAL_PRICE") }}
          </th>
          <th class="actions-header">{{ $t("BUTTON.ACTIONS") }}</th>
        </tr>
      </thead>
      <tbody>
        <ServiceInvoiceRowItem
          v-for="(row, index) in rows"
          :key="`row-${row.id || row.tempId}-${index}`"
          :row="row"
          :machines="machines"
          :serviceWarehouseItems="serviceWarehouseItems"
          :hasError="hasRowError(index)"
          :hasNameError="hasRowFieldError(index, 'name')"
          :hasPriceError="hasRowFieldError(index, 'price')"
          :hasQtyError="hasRowFieldError(index, 'totalQty')"
          :hasMachineError="hasRowFieldError(index, 'machine')"
          :hasWarehouseError="hasRowFieldError(index, 'serviceWarehouseItem')"
          @update-field="
            (field, value) => $emit('update-row', index, field, value)
          "
          @delete="$emit('delete-row', index)"
        />

        <tr>
          <td colspan="4" class="text-right font-weight-bold">
            {{ $t("LABELS.TOTAL") }}:
          </td>
          <td class="font-weight-bold">{{ totalQty }}</td>
          <td></td>
          <td class="font-weight-bold">{{ totalSum }} &euro;</td>
          <td></td>
        </tr>
      </tbody>
    </table>

    <div v-else class="pa-5 text-center text-muted">
      <v-icon large color="grey lighten-1">mdi-inbox</v-icon>
      <p class="mt-3">{{ $t("LABELS.NO_ADDED_ROWS") }}</p>
    </div>
  </v-card>
</template>

<script>
import ServiceInvoiceRowItem from "./ServiceInvoiceRowItem.vue";

export default {
  name: "ServiceInvoicesRowsTable",
  components: {
    ServiceInvoiceRowItem
  },
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    machines: {
      type: Array,
      default: () => []
    },
    serviceWarehouseItems: {
      type: Array,
      default: () => []
    },
    rowsWithErrors: {
      type: Array,
      default: () => []
    },
    rowValidationErrors: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    totalSum() {
      if (!this.rows) return "0.00";
      return this.rows
        .reduce((sum, r) => sum + parseFloat(r.totalPrice || 0), 0)
        .toFixed(2);
    },
    totalQty() {
      if (!this.rows) return "0.00";
      return this.rows
        .reduce((sum, r) => sum + parseFloat(r.totalQty || 0), 0)
        .toFixed(2);
    }
  },
  methods: {
    hasRowError(index) {
      return this.rowsWithErrors.includes(index);
    },
    hasRowFieldError(index, fieldName) {
      return this.rowValidationErrors[index]?.[fieldName] === true;
    }
  }
};
</script>

<style scoped>
.rows-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.rows-table th,
.rows-table td {
  text-align: left;
  padding: 8px 10px;
  border-bottom: 1px solid #e0e0e0;
  font-size: 13px;
}

.rows-table th {
  background-color: #fafafa;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  color: #666;
}

.rows-table th:first-child,
.rows-table td:first-child {
  padding-left: 24px;
}

.name-header {
  width: 13%;
}

.code-header {
  width: 10%;
}

.machine-header {
  width: 22%;
}

.warehouse-header {
  width: 15%;
}

.qty-header {
  width: 7%;
}

.price-header {
  width: 8%;
}

.total-price-header {
  width: 10%;
}

.actions-header {
  width: 8%;
}
</style>
